export const assetTypes = [
    'Amelia',
    'Airplane',
    'CancellationInsurance',
    'Car',
    'Circle',
    'Ferry',
    'FerryPlus',
    'Klarna',
    'LeaBankLarge',
    'LeaBankSmall',
    'Luggage',
    'LuggageInsurance',
    'MobileChat',
    'PackingCar',
    'PersonalAssistant',
    'Queue',
    'Relaxing',
    'Ryanair',
    'RyanairTransparent',
    'Selection',
    'Sembonus',
    'Stay',
    'Transfer',
    'VerifiedByRyanair',
    'WarningSign',
] as const;

export type Type = (typeof assetTypes)[number];
